export const mutations = {
  setOrg: function (state, data) {
    state.org = data;
  },
};
